

















import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class AppHeader extends Vue {
  private mounted() {
    window.addEventListener('scroll', this.scrollEvent);
  }

  private destroyed() {
    window.removeEventListener('scroll', this.scrollEvent);
  }

  private scrollEvent() {
    if (window.innerHeight < window.scrollY) {
      (this.$refs.header as HTMLDivElement).className = 'app-header fixed';
    } else {
      (this.$refs.header as HTMLDivElement).className = 'app-header';
    }
  }
}
